<img [src]="post.mediaUrl" *ngIf="post.hasImage" alt="image-file" class="margin-1 image-viewer" />
